import React from "react";
import theme from "app/Theme/Theme";
import Svg, { Path } from "react-native-svg";
import normalize from "app/utils/normalize";

const TeamIcon = ({
  height = normalize(24),
  width = normalize(24),
  color = theme.colors["neutral.900"],
  ...props
}) => (
  <Svg
    width={width}
    height={height}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 24 24"
    {...props}
  >
    <Path
      d="M14.5 6.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm5 .5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-13 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM8 11.25c0-.69.56-1.25 1.25-1.25h5.5c.69 0 1.25.56 1.25 1.25V16a4 4 0 1 1-8 0v-4.75Zm-1 0c0-.463.14-.892.379-1.25H5.25C4.56 10 4 10.56 4 11.25V15a3 3 0 0 0 3.404 2.973A4.983 4.983 0 0 1 7 16v-4.75ZM17 16c0 .7-.144 1.368-.404 1.973A3 3 0 0 0 20 15v-3.75c0-.69-.56-1.25-1.25-1.25h-2.129c.24.358.379.787.379 1.25V16Z"
      fill={color}
    />
  </Svg>
);

export default TeamIcon;
